import { useState, useEffect } from 'react';
import { Col, Row, Divider, Checkbox, AutoComplete, Table } from 'antd';
import Form from 'react-bootstrap/Form';
import RicercaCodiceSvc from 'services/ricercaCodice';
import Loading from 'components/loading';
import _ from 'lodash';
import '../../css/_ricercaCodice.scss';

const RicercaCodice = ({ isMobile }) => {
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);
  const [valueList, setValueList] = useState([]);
  const [filteredValueList, setFilteredValueList] = useState([]);
  const [checked, setChecked] = useState();
  const [selectedValue, setSelectedValue] = useState();
  const [selected, setSelected] = useState(false);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    document.title = 'Ricerca codice Istat - SITUAS';
    let mounted = false;
    const fetchList = async () => {
      try {
        const { data } = await RicercaCodiceSvc.getList();
        if (!mounted) {
          setList(data.items);
          setLoading(false);
        }
      } catch {
        setLoading(false);
      }
    };
    fetchList();
    return () => {
      mounted = true;
    };
  }, []);
  useEffect(() => {}, [isChecked, selected]);

  useEffect(() => {
    let mounted = false;
    if (!mounted) {
      setSelectedValue();
    }
    const fetchValueList = async () => {
      if (checked) {
        setLoading(true);
        try {
          const { data } = await RicercaCodiceSvc.getValueList(checked.return_code);
          if (!mounted) {
            setValueList(data?.resultset);
            setFilteredValueList(
              data?.resultset.map(({ V, RC }) => ({ label: V, value: RC, key: V + RC }))
            );
            setLoading(false);
          }
        } catch {
          setLoading(false);
        }
      }
    };
    fetchValueList();
    return () => {
      mounted = true;
    };
  }, [checked]);

  const seqrchBTN = () => {
    const mounted = false;
    if (!mounted) {
      if (selected) {
        setLoading(true);
      }
      setColumns([]);
      setRows([]);
    }
    const getDetail = async () => {
      try {
        const { data } = await RicercaCodiceSvc.getDetail(checked.return_code, selectedValue.value);
        const formattedCols = Object.keys(data.resultset[0]).map((key) => ({
          //title: _.capitalize(key.replaceAll('_', ' ')),
          title: key,
          onCell: () => ({
            style: { textAlign: 'left' }
          }),
          dataIndex: key,
          key: key
        }));
        const formattedRows = data.resultset.map((row) => {
          const rowVal = Object.values(row);
          let rowObject = { key: rowVal[0] + rowVal[rowVal.length - 1] };
          Object.keys(row).forEach((value) => {
            rowObject = { ...rowObject, [value]: row[value] };
          });
          return rowObject;
        });
        if (!mounted) {
          setColumns(formattedCols);
          setRows(formattedRows);
          setLoading(false);
        }
      } catch {
        setLoading(false);
      }
    };
    if (selectedValue && selected) {
      getDetail();
    }
  }; /* , [selectedValue, selected, checked?.return_code] */

  const search = (inputValue) => {
    setSelected(false);
    setSelectedValue({ label: inputValue });
    if (inputValue?.length > 0) {
      let filtered = valueList
        .filter((value) =>
          value.V.split('-')[1].toLowerCase().trim().startsWith(inputValue.toLowerCase())
        )
        .map(({ V, RC }) => ({ label: V, value: RC, key: V + RC }));

      if (!filtered.length) {
        filtered = valueList
          .filter((value) =>
            value.V.split('-')[0].toLowerCase().trim().startsWith(inputValue.toLowerCase())
          )
          .map(({ V, RC }) => ({ label: V, value: RC, key: V + RC }));
      }

      if (!filtered.length) {
        filtered = valueList
          .filter((value) => value.V.toLowerCase().trim().startsWith(inputValue.toLowerCase()))
          .map(({ V, RC }) => ({ label: V, value: RC, key: V + RC }));
      }
      setFilteredValueList(filtered);
    } else {
      setFilteredValueList(valueList.map(({ V, RC }) => ({ label: V, value: RC, key: V + RC })));
    }
  };
  const searchCodice = (inputValue) => {
    setSelected(false);
    setSelectedValue({ label: inputValue });
    if (inputValue?.length > 0) {
      const filtered = valueList
        .filter((value) =>
          value.V.split('-')[0].toLowerCase().trim().startsWith(inputValue.toLowerCase())
        )
        .map(({ V, RC }) => {
          ({ label: V, value: RC, key: V + RC });
        });
      setFilteredValueList(filtered);
    } else {
      setFilteredValueList(valueList.map(({ V, RC }) => ({ label: V, value: RC, key: V + RC })));
    }
  };

  return (
    <>
      {loading && <Loading fullPage />}
      <Row className="box">
        <Col sm={0} lg={7}>
          <form className="mt-5 pt-2 d-flex flex-column justify-content-start" role="search">
            <div>
              <fieldset role="radiogroup" aria-describedby="criteri1-desc">
                <legend className="text-secondary">Criteri di ricerca</legend>
                <p className="sr-only" id="criteri1-desc">
                  I risultati vengono mostrati simultaneamente all'impostazione dei filtri
                </p>

                {list.map(({ return_code, label_tipologia }, idx) => {
                  return (
                    <Form.Check
                        id={'criteri1' + idx}
                      type="radio"
                      name="criteri1"
                      tabIndex={0}
                      aria-label={label_tipologia}
                      key={label_tipologia}
                      className="ml-2"
                      label={label_tipologia}
                      checked={checked?.label_tipologia === label_tipologia}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setChecked({ return_code, label_tipologia });
                          setSelectedValue();
                          setSelected(false);
                          setIsChecked(true);
                        } else {
                          setChecked();
                          setIsChecked(false);
                          setSelectedValue();
                          setSelected(false);
                        }
                      }}></Form.Check>
                  );
                })}
              </fieldset>
            </div>
            <div style={{ width: '80%' }}>
              <fieldset>
                {checked && valueList.length > 0 && (
                  <>
                    <Form.Group className="flex-wrapped">
                      <Form.Label for="Ricerca">{checked?.label_tipologia}</Form.Label>
                      <AutoComplete
                        tabIndex={0}
                        id="ricerca"
                        dropdownClassName="storia-ua-denominazione"
                        value={selectedValue?.label}
                        options={filteredValueList}
                        onSelect={(_, obj) => {
                          setSelectedValue(obj);
                          setSelected(true);
                        }}
                        onSearch={search}
                        className="mb-3 ml-2"
                        style={{ minWidth: 225, flexGrow: 1 }}
                        placeholder="Codice/Denominazione"
                      />
                    </Form.Group>
                  </>
                )}
              </fieldset>
            </div>
            <button
              tabIndex={0}
              type="button"
              disabled={!checked || !selected ? true : false}
              className="storia-ua-button mt-2 btnwd"
              onClick={() => {
                seqrchBTN();
              }}>
              Cerca
            </button>
            <button
              tabIndex={0}
              className="storia-ua-button btnwd"
              type="submit"
              onClick={() => {
                setSelectedValue();
                setSelected(false);
                setChecked();
                setIsChecked(false);
                setColumns([]);
                setRows([]);
              }}>
              Annulla
            </button>
          </form>
        </Col>
        <Col sm={23} lg={16} offset={1}>
          <h2 className="title-main">Ricerca codice Istat</h2>
          <Divider className="blue-divider" />
          <div className="d-flex justify-content-start" role="status">
            {!columns.length > 0 ? (
              <span>
                Dopo aver selezionato l'unità e ricercato codice-denominazione di interesse, il sistema restituisce l'elenco dei codici e denominazioni dell'unità stessa con relativo periodo di validità.
              </span>
            ) : (
              <Table
                className="mb-5 no-wrap"
                scroll={{ x: 500 }}
                bordered
                dataSource={rows}
                columns={columns}
                pagination={false}
              />
            )}
          </div>
        </Col>
      </Row>
    </>
  );
};
export default RicercaCodice;
